import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "Airborne sound insulation - Standardized level difference",
  description:
    "Standardized level difference DnT is shown for each source position and averaged value for two source positions in the relevant one-third octave bands.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/05/22/principle/principle-7.svg`,
            },
          },
        },
      },
    },
  },
};

export default principle;
